// extracted by mini-css-extract-plugin
export var control = "styles-module__control____IVyZ";
export var isMapExpanded = "styles-module__isMapExpanded___bDFJ2";